'use strict';

angular.module('lingApp')
  .directive('ripPositionCenter', function ($timeout) {
    return function(scope, element, attrs) {
      var centerCounter = 0;
      var offset = { width: element[0].offsetWidth,
                     height: element[0].offsetHeight };

      scope.$watch(monitoringCenter, asyncCenter);

      function monitoringCenter() {
        var width = element[0].offsetWidth;
        var height = element[0].offsetHeight;

        if (5 < Math.abs(width - offset.width)
            || 5 < Math.abs(height - offset.height)) {
          ++centerCounter;
        }

        return centerCounter;
      }

      function asyncCenter() {
        center();
        $timeout(center);
      }

      function center() {
        offset.width = element[0].offsetWidth;
        offset.height = element[0].offsetHeight;

        var top = Math.max(5, offset.height >> 1);
        var left = Math.max(5, offset.width >> 1);

        element[0].style.top = '50%';
        element[0].style.left = '50%';
        element[0].style.marginLeft = -left + 'px';
        element[0].style.marginTop = -top + 'px';
      }
    };
  });
